import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { PuffLoader } from "react-spinners";
import { useTranslation } from "react-i18next";

const FullscreenPuffLoader = ({ delay = 0.5 }) => {
  const { t } = useTranslation("components");

  return (
    <motion.div
      role="status"
      transition={{ delay }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        position: "fixed",
        width: "100%", height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
      }}>
      <PuffLoader color="white" />
      <span className="visually-hidden">{t("status.loading")}</span>
    </motion.div>
  );
};

FullscreenPuffLoader.propTypes = {
  delay: PropTypes.number,
}

export default FullscreenPuffLoader;
